// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2573":"5bb31413","2819":"5bb31413","8882":"5bb31413"}[chunkId] + ".chunk.css";
};